import { ReactNode, useState, MouseEvent } from 'react'
import { Box, Chip, Popover, Skeleton, Typography, useTheme } from '@mui/material'

import { FONTS, SPACES } from 'src/constants'

interface IProps {
  count: number | null
  isLoading: boolean
  hoverText: string | ReactNode
  size?: 'small' | 'medium'
}

export const CountChip = ({ count, isLoading, hoverText, size = 'medium' }: IProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)
  const theme = useTheme()

  const handlePopoverOpen = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handlePopoverClose = () => {
    setAnchorEl(null)
  }

  return (
    <>
      {isLoading && (
        <Skeleton
          sx={{ marginLeft: SPACES.xxxs }}
          variant="circular"
          width={size === 'small' ? 14 : 20}
          height={size === 'small' ? 14 : 20}
          className="count-chip"
        />
      )}
      {!isLoading && count && count > 0 ? (
        <>
          <Chip
            onMouseEnter={handlePopoverOpen}
            onMouseLeave={handlePopoverClose}
            size="small"
            className="count-chip"
            sx={{
              height: size === 'small' ? '14px' : '22px',
              display: 'flex',
              textAlign: 'center',

              marginLeft: size === 'small' ? 0 : SPACES.xxxs,
              backgroundColor: '#E57373',
              color: theme.palette.custom.white,
              '.MuiChip-label': {
                px: size === 'small' ? '3px' : '8px',
              },
            }}
            label={
              <Typography sx={{ fontSize: size === 'small' ? '9px' : '12px' }}>{count}</Typography>
            }
          />
          <Popover
            sx={{ pointerEvents: 'none' }}
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            onClose={handlePopoverClose}
            disableRestoreFocus
            disableScrollLock
          >
            <Box sx={{ padding: SPACES.xxs, textAlign: 'center', maxWidth: '350px' }}>
              <Typography
                sx={{
                  fontSize: '12px',
                  color: theme.palette.custom.darkBlue2,
                  fontWeight: FONTS.WEIGHTS.semi_bold,
                }}
              >
                {hoverText}
              </Typography>
            </Box>
          </Popover>
        </>
      ) : null}
    </>
  )
}
